import React,{useState,useEffect} from 'react';
//import FormHelperText from '@mui/material/FormHelperText';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import Hidden from '@mui/material/Hidden';
import PrintDisabledIcon from '@mui/icons-material/PrintDisabled';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import FormControl from '@mui/material/FormControl';
import BottomButtons from './BottomButtons';
import useMediaQuery from '@mui/material/useMediaQuery';
import {Theme} from './Theme';
import {Tools} from './Tools';
import {Item,Owner} from './Inc';
import StoreImg from './StoreImg';
import useStyles from './Styles';

interface Props {
	isOpen:boolean,
    items:Item[],
    owner:Owner,
    next(items:Item[],values:number[],flag:boolean):void,
    close(): void,
}

const LetterConfirm = (props:Props)=> {
    const classes = useStyles();
	const fullScreen = useMediaQuery(Theme.breakpoints.down('sm'));

	const defValues:number[] = new Array<number>(props.items.length).fill(1);
    const [values,setValues] = useState(defValues);
    const change = (index:number)=>(event: React.ChangeEvent<HTMLInputElement>) => {
        let vs = values.concat();
        let v = Tools.toHan(event.target.value);
        if( v==="" ){
            v = "0";
        }
        vs[index] = parseInt(v);
        setValues(vs);
    }

	const send1= ()=>{
        props.next(props.items,values,true);
    }

	const send3= ()=>{
        props.next(props.items,values,false);
    }

	useEffect(()=>{
		if(props.isOpen){
			setValues(defValues);
		}
	},[props.isOpen]);

	if(!props.isOpen){
		return (null);
	}

	let error = false;

	return (
		<Dialog
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={true}
			onClose={(event: object, reason: string) =>{
				if( reason!=="backdropClick" ){
					props.close();
				}
			}}
			fullScreen={fullScreen}
		>
			<DialogTitle color='primary'>納品数の入力</DialogTitle>
			<DialogContent dividers>
				<div className={classes.confirmGuide}>
				納品数を入力して「出力する」を押すとPDFで納品書（商品委託書）が出力されます。<br/>
				PDFの出力・保存ができない場合は「手書き納品」を押してください。<br/>
				</div>
				<div style={{marginBottom:"2em"}}>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell className={classes.tableHeadNowrap} align='center'>商品</TableCell>
								<Hidden smDown implementation="js">
									<TableCell className={classes.tableHeadNowrap} align="center">画像</TableCell>
								</Hidden>
								<TableCell className={classes.tableHeadNowrap} align='center'>在庫</TableCell>
								<TableCell className={classes.tableHeadNowrap} align='center'>納品数</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
					{props.items.map( (item:Item,index:number)=>{
						const key = "item"+index;
						if( values[index]===0 ){
							error = true;
						}
						return (
							<TableRow key={key}>
								<TableCell className={classes.tableCellDense}>
									<span className={classes.itemId}>ID:{item.item_id}</span>　
									<Hidden smUp implementation="js">
										<br/>
									</Hidden>
									{item.item_name}
								</TableCell>
								<Hidden smDown implementation="js">
									<TableCell className={classes.tableCellDense} align="center"><StoreImg owner_id={props.owner.owner_id} img_id={item.img_id} className="imgList"/></TableCell>
								</Hidden>
								<TableCell className={classes.tableCellNowrap} align="right">{item.num_stock}</TableCell>
								<TableCell align='right'>
									<input type="text" className={classes.input} style={{width:"4em",marginRight:"0.5em"}} onChange={change(index)} value={values[index]}/>{item.unit}
								</TableCell>
							</TableRow>
						);
					})}
						</TableBody>
					</Table>
				</div>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<FormControl fullWidth={true} style={{marginLeft:'0.5em'}}>
					<BottomButtons button1='出力する' onClick1={send1} disabled1={error} button2="選びなおす" onClick2={props.close} button3="手書き納品" icon3={<PrintDisabledIcon/>} onClick3={send3} disabled3={error} top={0} bottom={0}/>
				</FormControl>
			</DialogActions>
		</Dialog>
	);
}

export default LetterConfirm;
